import styled from "styled-components";

const WSBottomContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
`;
export default WSBottomContainer;
